<template>
  <div ref="appNavigation" class="modal navigation navigation--main fade">
    <div class="navigation__dialog">
      <div class="navigation__content">
        <div class="navigation__menu">

          <ul class="nav nav-pills">
            <li v-for="(item, index) in menuItems" :key="index">
              <a href="item.url">
                <span :class="item.icon"></span>
                {{item.label}}
              </a>
            </li>
          </ul>

          <div class="navigation__contact">
            <a href="mailto:fernando.garcia.f2@gmail.com" class="btn btn--primary btn-block">Contact Me</a>
          </div>
        </div>
      </div><!-- /.navigation-content -->
    </div><!-- /.navigation-dialog -->
  </div><!-- /.navigation -->
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  props: {
    menuItems: Array
  },
  data () {
    return {
      instance: null
    }
  },
  computed: {
    navActive: get('Interface/navActive')
  },
  methods: {
    setNavActive: call('Interface/setNavActive'),
    openNavigation: function () {
      if (this.instance !== null) this.instance.show()
    },
    createNavIntance: function () {
      if (this.instance === null) this.instance = new this.$Bootstrap.Modal(this.$refs.appNavigation)
    },
    setNavEventHandlers: function () {
      this.$refs.appNavigation.addEventListener('hide.bs.modal', (event) => this.setNavActive(false), false)
    },
    removeNavEventHandlers: function () {
      this.$refs.appNavigation.removeEventListener('hide.bs.modal', (event) => this.setNavActive(false), false)
    }
  },
  mounted: function () {
    this.createNavIntance()
    this.setNavEventHandlers()
  },
  destroyed: function () {
    this.removeNavEventHandlers()
  },
  watch: {
    navActive: function (v) {
      if (v) {
        this.openNavigation()
      }
    }
  }
}
</script>

<style scoped></style>
